import { trustDeedList } from 'json/trust-deed'
import { terrace,departementList } from 'json/lab-order'

export let tabs = [{
    label: '全部委托单',
    value: 'ALL'
  },
  ...trustDeedList
]
export let filterLabels = [{
    label: '委托方',
    slotName: 'organizationId'
  }, {
    label: '结算',
    type: 'select',
    clearable: true,
    value: 'settlement', // 需返回数据的字段名
    options: [{
      label: '已结算',
      value: 'true'
    }, {
      label: '未结算',
      value: 'false'
    }]
  }, {
    label: '开票',
    type: 'select',
    clearable: true,
    value: 'invoice', // 需返回数据的字段名
    options: [{
      label: '已开票',
      value: 'true'
    }, {
      label: '未开票',
      value: 'false'
    }]
  }, {
    label: '状态',
    type: 'select',
    clearable: true,
    value: 'billStatusEnum', // 需返回数据的字段名
    options: trustDeedList
  }, {
    label: '是否返还',
    type: 'select',
    clearable: true,
    value: 'back', // 需返回数据的字段名
    options: [{
      label: '是',
      value: 'true'
    }, {
      label: '否',
      value: 'false'
    }]
  }, {
    label: '是否加急',
    type: 'select',
    clearable: true,
    value: 'urgent', // 需返回数据的字段名
    options: [{
      label: '是',
      value: 'true'
    }, {
      label: '否',
      value: 'false'
    }]
  },
  // {
  //   label: '是否偏离',
  //   type: 'select',
  //   clearable: true,
  //   value: 'deviate', // 需返回数据的字段名
  //   options: [{
  //     label: '是',
  //     value: 'true'
  //   }, {
  //     label: '否',
  //     value: 'false'
  //   }]
  // }, 
  {
    label: '交付方式',
    type: 'select',
    clearable: true,
    value: 'deliveryType', // 需返回数据的字段名
    options: terrace
  },{
    label: '所属科室',
    type: 'select',
    clearable: true,
    allowCreate:true,
    value: 'departmentName', // 需返回数据的字段名
    options: departementList
  }, {
    label: '开始时间',
    type: 'date',
    clearable: true,
    value: 'createdDateStart', // 需返回数据的字段名
  }, {
    label: '结束时间',
    type: 'date',
    clearable: true,
    value: 'createdDateEnd', // 需返回数据的字段名
  }, {
    label: '是否催缴',
    type: 'select',
    clearable: true,
    value: 'isCall', // 需返回数据的字段名
    options: [{
      label: '是',
      value: 'true'
    }, {
      label: '否',
      value: 'false'
    }]
  }, {
    label: '是否逾期',
    type: 'select',
    clearable: true,
    value: 'overDue', // 需返回数据的字段名
    options: [{
      label: '是',
      value: 'true'
    }, {
      label: '否',
      value: 'false'
    }]
  }
]

export const tableLabels = [{
    label: '委托单编号',
    value: 'billCode',
    slotName: '',
    minWidth: '150px'
  },
  {
    label: '委托方',
    value: 'organization.base.name',
    minWidth: '120px'
  },
  {
    label: '所属科室',
    value: 'departmentName',
    minWidth: '120px'
  },
  {
    label: '指标数量',
    value: 'orderNum',
    minWidth: '120px'
  },
  {
    label: '样品总数量',
    value: 'realSampleCount',
    minWidth: '120px'
  },
  {
    label: '交付方式',
    value: 'delivery_type',
    minWidth: '120px'
  },
  {
    label: '报告份数',
    slotName: 'reportNum',
    minWidth: '120px'
  },
  {
    label: '是否返还',
    value: 'back_text',
    minWidth: '120px'
  },
  {
    label: '合计总金额',
    value: 'billAmount',
    minWidth: '120px'
  },
  {
    label: '是否催缴',
    value: 'isCall_text',
    minWidth: '120px'
  },
  {
    label: '结算',
    value: 'settlement_text',
    minWidth: '120px'
  },
  {
    label: '开票',
    value: 'invoice_text',
    minWidth: '120px'
  },
  {
    label: '状态',
    slotName: 'billStatusEnum',
    minWidth: '160px'
  },

  {
    label: '创建日期',
    value: 'created_date',
    minWidth: '120px'
  },
  {
    label: '交付日期',
    value: 'delivery_date',
    minWidth: '120px'
  },
  {
    label: '操作',
    slotName: 'operate',
    fixed: 'right',
    minWidth: '195px'
  }
]